// extracted by mini-css-extract-plugin
export var noResultPage = "no-result-page_AIFzPJpqjcwiitOFtxy7";
export var noResultPageDescription = "no-result-page-description_VBOgTwU2H7Nhnl9fAnS0";